import classNames from "classnames";
import { useState } from "react";
import Products from "./Products";
import SettingsContainer from "./SettingsContainer";
// import Popup from "../Popup";
import DesignNotes from "./DesignNotes";
import Account from "./Account";
import AddText from "./AddText";
import UploadDesign from "./UploadDesign";
import { useAppDispatch, useAppSelector } from "../../../../hooks/reduxHooks";
import { deSelectObject } from "../../../store/slices/viewSlice";
import { goToDesign } from "../../../store/slices/stepSlice";
import { goToSidebarTab } from "../../../store/slices/sidebarSlice";
import Popup from "../Popup";
import SaveDesign from "../SaveDesign";
import ShareAndSave from "../../../../components/Header_new/ShareAndSave";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
declare global {
  interface Window {
    design_canvas: any;
  }
}

const Sidebar = () => {
  const [showSaveSharePopup, setSaveSharePopup] = useState(false);
  const dispatch = useAppDispatch();
  const currentStep = useAppSelector((state) => state.steps.step);
  const currentTab = useAppSelector((state) => state.sidebar.tab);
  const { productId, designId } = useParams<{
    productId: string;
    designId: string;
  }>();

  const [showSetting, setShowSetting] = useState(true);
  const [showSaveDesign, setShowSaveDesign] = useState(false);
  const isLoggedIn = false;
  const selectedObject = useAppSelector(
    (state: any) => state.canvases.selectedObject
  );

  const handleShow = (title: any) => {
    if (selectedObject) {
      if (selectedObject.type !== "image" && title === "Upload Image")
        dispatch(deSelectObject(false));
      else if (title === "Products" || title === "Design Notes")
        dispatch(deSelectObject(false));
      else if (title === "Add Text" && selectedObject.type !== "text")
        dispatch(deSelectObject(false));
    }

    dispatch(goToDesign());
    dispatch(goToSidebarTab({ tab: title }));
    setShowSetting(true);
  };

  const handleClose = () => {
    setShowSetting(false);
  };

  // function isValidCanvasData() {
  //   const nonLineObject = window?.design_canvas[
  //     productId as any
  //   ]?._objects?.filter((canvas: any) => {
  //     // Check if the type is 'line' or not
  //     return !(canvas.type === "line");
  //   });

  //   if (nonLineObject?.length > 0) {
  //     return { showPopup: true };
  //   }

  //   return null; // No valid designs
  // }

  function isValidCanvasData() {
    try {
      // Get the canvas for the current product

      const viewKeys = Object.keys(window?.design_canvas);
      const canvas = window?.design_canvas?.[viewKeys[0]];

      if (!canvas || !canvas._objects) {
        console.log("No canvas or objects found");
        return null;
      }

      // Filter for meaningful objects (not lines, guidelines, etc.)
      const validObjects = canvas._objects.filter((obj: any) => {
        return (
          obj &&
          obj.type !== "line" &&
          obj.type !== "guideline" &&
          obj.type !== "activeSelection" &&
          !obj.excludeFromExport
        );
      });

      console.log("Valid objects found:", validObjects);

      if (validObjects && validObjects.length > 0) {
        return { showPopup: true };
      } else {
        console.log("No valid design objects found on canvas");
        return null;
      }
    } catch (error) {
      console.error("Error checking canvas data:", error);
      return null;
    }
  }

  return (
    <>
      <div className="py-1 lg:py-5 bg-darknavy text-white text-xs max-lg:text-[10px] text-center w-full lg:w-[78px] lg:h-[calc(100vh-70px)] fixed max-lg:bottom-0 lg:leading-4 flex lg:flex-col justify-center lg:justify-between z-40 max-lg:overflow-x-scroll max-lg:whitespace-nowrap max-lg:justify-start max-lg:p-0">
        <div className="flex lg:flex-col gap-2 w-full">
          <div className="flex lg:flex-col gap-2 w-full max-lg:justify-between max-lg:px-[5%]">
            <button
              onClick={() => handleShow("Products")}
              className={classNames(
                "px-3 max-lg:px-2 lg:border-x-[3px] border-solid hover:border-l-primaryred max-lg:w-[60px] max-lg:h-[60px] max-lg:flex max-lg:flex-col max-lg:items-center max-lg:justify-center",
                {
                  "border-transparent": currentTab !== "Products",
                  "bg-white text-black border-primaryred border-r-transparent shadow-header":
                    currentTab === "Products",
                }
              )}
            >
              <svg
                className={classNames("max-lg:w-[30px] max-lg:h-[30px] mx-auto", {
                  "fill-white": currentTab !== "Products",
                  "fill-black": currentTab === "Products",
                })}
                height="44px"
                width="36px"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 230.057 230.057"
                xmlSpace="preserve"
              >
                <g>
                  <path
                    d="M228.579,83.315l-32.147-41.258c-7.817-10.032-19.594-15.785-32.312-15.785h-21.204c-2.939,0-5.565,1.836-6.574,4.597
		c-3.257,8.909-11.822,14.895-21.313,14.895s-18.055-5.986-21.313-14.895c-1.009-2.761-3.635-4.597-6.574-4.597H65.937
		c-12.717,0-24.495,5.753-32.312,15.786L1.479,83.315c-1.397,1.793-1.837,4.152-1.179,6.328c0.658,2.176,2.331,3.897,4.488,4.615
		l44.558,14.845v87.682c0,3.866,3.134,7,7,7h117.366c3.866,0,7-3.134,7-7v-87.682l44.558-14.845c2.157-0.718,3.83-2.439,4.488-4.615
		C230.416,87.467,229.976,85.108,228.579,83.315z M180.712,94.347V84.057c0-3.866-3.134-7-7-7s-7,3.134-7,7v105.728H63.345V84.057
		c0-3.866-3.134-7-7-7s-7,3.134-7,7v10.29l-30.736-10.24l26.059-33.444c5.146-6.604,12.897-10.391,21.269-10.391h16.681
		c6.295,11.832,18.761,19.491,32.41,19.491c13.649,0,26.115-7.66,32.411-19.491h16.681c8.371,0,16.123,3.787,21.269,10.39
		l26.06,33.445L180.712,94.347z"
                  />
                </g>
              </svg>
              Products
            </button>
            <button
              onClick={() => handleShow("Add Text")}
              className={classNames(
                "px-3 max-lg:px-2 lg:border-x-[3px] border-solid hover:border-l-primaryred max-lg:w-[60px] max-lg:h-[60px] max-lg:flex max-lg:flex-col max-lg:items-center max-lg:justify-center",
                {
                  "border-transparent": currentTab !== "Add Text",
                  "bg-white text-black border-primaryred border-r-transparent shadow-header":
                    currentTab === "Add Text",
                }
              )}
            >
              <svg
                className={classNames("max-lg:w-[30px] max-lg:h-[30px] mx-auto", {
                  "fill-white": currentTab !== "Add Text",
                  "fill-black": currentTab === "Add Text",
                })}
                width="50"
                height="50"
                viewBox="0 0 50 50"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_43877_32905)">
                  <path d="M18.9455 37.2627V34.0046H22.7936V16.0467H17.8937V21.2801H14.3406V12.7373H35.6592V21.2288H32.0676V15.9954H27.2061V33.9533H31.0543V37.2114H18.9455V37.2627Z" />
                </g>
                <defs>
                  <clipPath id="clip0_43877_32905">
                    <rect width="50" height="50" />
                  </clipPath>
                </defs>
              </svg>
              Add Text
            </button>
            <button
              onClick={() => handleShow("Upload Image")}
              className={classNames(
                "px-3 max-lg:px-2 lg:border-x-[3px] border-solid hover:border-l-primaryred max-lg:w-[60px] max-lg:h-[60px] max-lg:flex max-lg:flex-col max-lg:items-center max-lg:justify-center",
                {
                  "border-transparent": currentTab !== "Upload Image",
                  "bg-white text-black border-primaryred border-r-transparent shadow-header":
                    currentTab === "Upload Image",
                }
              )}
            >
              <svg
                className={classNames("max-lg:w-[30px] max-lg:h-[30px] mx-auto", {
                  "fill-white": currentTab !== "Upload Image",
                  "fill-black": currentTab === "Upload Image",
                })}
                width="50"
                height="50"
                viewBox="0 0 50 50"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_43891_33278)">
                  <path d="M35.8005 20.4079H35.3515V19.7281C35.3498 17.8529 34.7051 16.035 33.525 14.5776C32.345 13.1203 30.7009 12.1117 28.867 11.72C27.0332 11.3283 25.1205 11.5773 23.4481 12.4254C21.7756 13.2734 20.4445 14.6693 19.6768 16.3802C19.0022 16.0787 18.2679 15.9341 17.5294 15.9573C16.7908 15.9805 16.0671 16.1709 15.4127 16.5141C14.7583 16.8574 14.1902 17.3446 13.7513 17.939C13.3123 18.5335 13.0139 19.2197 12.8785 19.9461C11.4796 20.3443 10.2713 21.2337 9.47543 22.4511C8.67958 23.6685 8.34962 25.1321 8.54614 26.5732C8.74265 28.0143 9.45245 29.3362 10.5452 30.296C11.6379 31.2559 13.0403 31.7893 14.4947 31.7984H19.3048L19.3818 31.6958L23.0888 28.1427C23.5863 27.6622 24.2508 27.3937 24.9423 27.3937C25.6339 27.3937 26.2984 27.6622 26.7959 28.1427L30.5157 31.7214L30.5927 31.824H35.7235C37.2374 31.8342 38.6933 31.2426 39.771 30.1794C40.8487 29.1161 41.4598 27.6683 41.47 26.1545C41.4803 24.6406 40.8887 23.1847 39.8254 22.107C38.7622 21.0293 37.3143 20.4181 35.8005 20.4079Z" />
                  <path d="M29.233 33.1067L25.526 29.5023C25.387 29.3668 25.2006 29.2909 25.0065 29.2909C24.8124 29.2909 24.6259 29.3668 24.487 29.5023L20.7671 33.0811C20.6586 33.1844 20.5838 33.318 20.5525 33.4645C20.5213 33.611 20.5349 33.7635 20.5917 33.9021C20.6486 34.0408 20.7459 34.159 20.8711 34.2413C20.9962 34.3237 21.1433 34.3664 21.2931 34.3638H23.1786V38.4813H26.8472V34.4023H28.7328C28.8831 34.4025 29.0301 34.3571 29.1541 34.2721C29.2782 34.1871 29.3736 34.0666 29.4278 33.9263C29.4819 33.786 29.4923 33.6326 29.4576 33.4863C29.4228 33.34 29.3445 33.2076 29.233 33.1067Z" />
                </g>
                <defs>
                  <clipPath id="clip0_43891_33278">
                    <rect width="50" height="50" />
                  </clipPath>
                </defs>
              </svg>
              Upload Image
            </button>
            {/* <button
              onClick={() => handleShow("Design Notes")}
              className={classNames(
                "px-3 max-lg:px-2 lg:border-x-[3px] border-solid hover:border-l-primaryred",
                {
                  "border-transparent": currentTab !== "Design Notes",
                  "bg-white text-black border-primaryred border-r-transparent shadow-header":
                    currentTab === "Design Notes",
                }
              )}
            >
              <svg
                className={classNames("max-lg:w-[35px] max-lg:h-[35px] mx-auto", {
                  "fill-white": currentTab !== "Design Notes",
                  "fill-black": currentTab === "Design Notes",
                })}
                width="50"
                height="50"
                viewBox="0 0 50 50"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M29.1523 10V14.264H35.3046L29.1523 10Z" />
                <path d="M36.8883 40H11V10H26.6701V16.0914H36.8883V40ZM14.0457 36.9543H33.8426V19.1371H23.6244V13.0457H14.0457V36.9543Z" />
                <path d="M15.7969 31.8527H27.7512V33.9086H15.7969V31.8527ZM15.7969 26.9492H32.9441V29.005H15.7969V26.9492ZM15.7969 22.0304H32.9441V24.0862H15.7969V22.0304Z" />
              </svg>
              Design Notes
            </button> */}
            <button
              onClick={() => {
                const canvasData = isValidCanvasData();
                if (canvasData) {
                  if (canvasData.showPopup) {
                    setSaveSharePopup(true);
                  }
                } else {
                  toast.error("Please add a design before saving.");
                }
              }}
              className={classNames(
                "px-3 max-lg:px-2 lg:border-x-[3px] border-solid hover:border-l-primaryred max-lg:w-[60px] max-lg:h-[60px] max-lg:flex max-lg:flex-col max-lg:items-center max-lg:justify-center",
                {
                  "border-transparent": currentTab !== "Save Design",
                  "bg-white text-black border-primaryred border-r-transparent shadow-header":
                    currentTab === "Save Design",
                }
              )}
            >
              <svg
                className={classNames("max-lg:w-[30px] max-lg:h-[30px] mx-auto", {
                  "fill-white": currentTab !== "Save Design",
                  "fill-black": currentTab === "Save Design",
                })}
                width="50"
                height="50"
                viewBox="0 0 50 50"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_43891_34101)">
                  <path d="M19.3988 15.5414H30.6019C30.9353 15.5414 31.2083 15.2693 31.2083 14.9353V10H18.7913V14.9353C18.7913 15.2693 19.0636 15.5414 19.3988 15.5414Z" />
                  <path d="M39.5313 17.5462L33.209 11.1973V14.9352C33.209 16.3727 32.0394 17.5423 30.6019 17.5423H19.3988C17.961 17.5423 16.7917 16.3727 16.7917 14.9352V10H12.7529C11.2324 10 10 11.2327 10 12.7521V37.248C10 38.7673 11.2324 40.0001 12.7529 40.0001H37.2477C38.7672 40.0001 39.9998 38.7675 39.9998 37.248V18.6801C39.9998 18.2543 39.8311 17.8468 39.5313 17.5462ZM35.3329 33.6873C35.3329 34.5739 34.6141 35.2937 33.7257 35.2937H16.2731C15.3855 35.2937 14.6668 34.5737 14.6668 33.6873V25.312C14.6668 24.4257 15.3855 23.706 16.2731 23.706H33.7257C34.6141 23.706 35.3329 24.4259 35.3329 25.312V33.6873Z" />
                  <path d="M31.8956 26.2842H18.104C17.5508 26.2842 17.1033 26.7309 17.1033 27.2841C17.1033 27.8373 17.5508 28.284 18.104 28.284H31.8957C32.4477 28.284 32.8954 27.8373 32.8954 27.2841C32.8954 26.7309 32.4478 26.2842 31.8956 26.2842Z" />
                  <path d="M29.8959 30.2845H20.1039C19.5515 30.2845 19.104 30.7312 19.104 31.2845C19.104 31.8365 19.5515 32.2844 20.1039 32.2844H29.8958C30.4482 32.2844 30.8958 31.8365 30.8958 31.2845C30.8958 30.7312 30.4483 30.2845 29.8959 30.2845Z" />
                </g>
                <defs>
                  <clipPath id="clip0_43891_34101">
                    <rect width="30" height="30" transform="translate(10 10)" />
                  </clipPath>
                </defs>
              </svg>
              Save Design
            </button>
            <button
              onClick={() => handleShow("Account")}
              className={classNames(
                "lg:hidden px-3 max-lg:px-2 lg:border-x-[3px] border-solid hover:border-l-primaryred max-lg:w-[60px] max-lg:h-[60px] max-lg:flex max-lg:flex-col max-lg:items-center max-lg:justify-center",
                {
                  "border-transparent": currentTab !== "Account",
                  "bg-white text-black border-primaryred border-r-transparent shadow-header":
                    currentTab === "Account",
                }
              )}
            >
              <svg
                className={classNames("max-lg:w-[30px] max-lg:h-[30px] mx-auto", {
                  "fill-white": currentTab !== "Account",
                  "fill-black": currentTab === "Account",
                })}
                width="50"
                height="50"
                viewBox="0 0 50 50"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_43891_34149)">
                  <path d="M25 10C16.72 10 10 16.72 10 25C10 33.28 16.72 40 25 40C33.28 40 40 33.28 40 25C40 16.72 33.28 10 25 10ZM25 14.5C27.49 14.5 29.5 16.51 29.5 19C29.5 21.49 27.49 23.5 25 23.5C22.51 23.5 20.5 21.49 20.5 19C20.5 16.51 22.51 14.5 25 14.5ZM25 35.8C21.25 35.8 17.935 33.88 16 30.97C16.045 27.985 22 26.35 25 26.35C27.985 26.35 33.955 27.985 34 30.97C32.065 33.88 28.75 35.8 25 35.8Z" />
                </g>
                <defs>
                  <clipPath id="clip0_43891_34149">
                    <rect width="30" height="30" transform="translate(10 10)" />
                  </clipPath>
                </defs>
              </svg>
              Account
            </button>
          </div>
        </div>
        <div className="hidden lg:flex lg:flex-col">
          <button
            onClick={() => handleShow("Account")}
            className={classNames(
              "px-3 lg:border-x-[3px] border-solid hover:border-l-primaryred",
              {
                "border-transparent": currentTab !== "Account",
                "bg-white text-black border-primaryred border-r-transparent shadow-header":
                  currentTab === "Account",
              }
            )}
          >
            <svg
              className={classNames("mx-auto", {
                "fill-white": currentTab !== "Account",
                "fill-black": currentTab === "Account",
              })}
              width="50"
              height="50"
              viewBox="0 0 50 50"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_43891_34149)">
                <path d="M25 10C16.72 10 10 16.72 10 25C10 33.28 16.72 40 25 40C33.28 40 40 33.28 40 25C40 16.72 33.28 10 25 10ZM25 14.5C27.49 14.5 29.5 16.51 29.5 19C29.5 21.49 27.49 23.5 25 23.5C22.51 23.5 20.5 21.49 20.5 19C20.5 16.51 22.51 14.5 25 14.5ZM25 35.8C21.25 35.8 17.935 33.88 16 30.97C16.045 27.985 22 26.35 25 26.35C27.985 26.35 33.955 27.985 34 30.97C32.065 33.88 28.75 35.8 25 35.8Z" />
              </g>
              <defs>
                <clipPath id="clip0_43891_34149">
                  <rect width="30" height="30" transform="translate(10 10)" />
                </clipPath>
              </defs>
            </svg>
            Account
          </button>
        </div>
      </div>
      {showSetting && currentStep === 0 && (
        <SettingsContainer handleClose={handleClose} title={currentTab}>
          {currentTab === "Products" && <Products />}
          {currentTab === "Add Text" && <AddText />}
          {currentTab === "Upload Image" && <UploadDesign />}
          {currentTab === "Design Notes" && <DesignNotes />}
          {currentTab === "Account" && <Account />}
        </SettingsContainer>
      )}
      {showSaveSharePopup && (
        <ShareAndSave
          setSaveSharePopup={setSaveSharePopup}
          isSaveDesignPopup={true}
        ></ShareAndSave>
      )}
    </>
  );
};

export default Sidebar;
